function* domIdentitiesIterator(domIdentities) {
  for (let i = 0; i < domIdentities.length; i += 6) {
    yield {
      identity: domIdentities[i],
      parentIndex: domIdentities[i + 1],
      top: domIdentities[i + 2],
      right: domIdentities[i + 3],
      bottom: domIdentities[i + 4],
      left: domIdentities[i + 5]
    };
  }
}
function* domIdentitiesReverseIterator(domIdentities) {
  for (let i = domIdentities.length - 6; i >= 0; i -= 6) {
    yield {
      identity: domIdentities[i],
      parentIndex: domIdentities[i + 1],
      top: domIdentities[i + 2],
      right: domIdentities[i + 3],
      bottom: domIdentities[i + 4],
      left: domIdentities[i + 5]
    };
  }
}
export {
  domIdentitiesIterator,
  domIdentitiesReverseIterator
};
//# sourceMappingURL=iterators.js.map
